import React, {
    useEffect,
    useReducer,
    useState
} from 'react';
import {
    Switch,
    Route,
    useLocation,
    Redirect,
    useHistory
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import styled, {
    ThemeProvider
} from "styled-components";
import {
    GlobalStyle,
    theme
} from "./style/index";
import { getEnvironment, loadThirdPartyScript } from "./utils/index";
import { tracking } from "./utils/index";
import LandingPage from "./pages/LandingPage";
import Modal from './modals/Modal';
import { Header } from './components-shared';
import { 
    addFormData
} from "./redux/index";
import { jwtTokenHelper } from "./utils/index";


const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    color: ${props => props.theme.codanColors.black};
`;



const App = () => {
    const [adobeTegManagerIsLoaded, setAdobeTegManagerIsLoaded] = useState(false);
    const isModalActive = useSelector(state => state.globalStyleReducer.modal.active);
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const background = location.state && location.state.background;

    useEffect(() => {
        jwtTokenHelper.getUserData(userData => {
            dispatch(addFormData(userData))
        });
        
        
    },[])

    useEffect(() => {
        loadThirdPartyScript('AdobeTagManager', getEnvironment() === 'production' ? "//assets.adobedtm.com/b28319220dd8/7f1f58633946/launch-00c7f9fc76d0.min.js" : "//assets.adobedtm.com/b28319220dd8/7f1f58633946/launch-e424f85ec229-staging.min.js", () => {
            setAdobeTegManagerIsLoaded(true);
        })
    }, []);

    tracking(adobeTegManagerIsLoaded);

    useEffect(() => {
        const locationSearch = sessionStorage.getItem('locationSearch')

        if (locationSearch && location.pathname === '/') {
            history.push({
                search: locationSearch
            })
        }
    }, [])


    return (
        <ThemeProvider theme={theme}>
            <Wrapper>
                <Header />
                <Switch location={background || location}>
                    <Route exact path={`/`} component={LandingPage} />
                    <Route exact path={`/:id`} component={Modal} />
                    <Route>{'404'}</Route>
                </Switch>
                {background && <Route exact path={`/:id`} children={<Modal />} />}
                <GlobalStyle isModalActive={isModalActive} />
            </Wrapper>
        </ThemeProvider>
    )
}

export default App;